import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16" aria-label="主导航">
        <Link
          to="/"
          className="flex items-center gap-2 text-foreground-900 hover:text-primary-500 transition-colors cursor-pointer"
        >
          <span className="text-xl md:text-2xl font-heading font-bold whitespace-nowrap">
            {siteConfig.name}
          </span>
          <span className="hidden sm:inline text-xs md:text-sm text-foreground-500 font-sans whitespace-nowrap">
            {siteConfig.tagline}
          </span>
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/category/newborn-care"
            className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            新生儿护理
          </Link>
          <Link
            to="/category/postpartum-recovery"
            className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            产后恢复
          </Link>
          <Link
            to="/category/breastfeeding"
            className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            母乳喂养
          </Link>
          <Link
            to="/category/early-education"
            className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            宝宝早教
          </Link>
          <Link
            to="/category/mom-growth"
            className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            妈妈成长
          </Link>
          <Link
            to="/about"
            className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            关于我们
          </Link>
        </div>

        {/* Mobile toggle */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-2">
            <Link to="/category/newborn-care" className="py-2 text-sm text-foreground-700 cursor-pointer">新生儿护理</Link>
            <Link to="/category/postpartum-recovery" className="py-2 text-sm text-foreground-700 cursor-pointer">产后恢复</Link>
            <Link to="/category/breastfeeding" className="py-2 text-sm text-foreground-700 cursor-pointer">母乳喂养</Link>
            <Link to="/category/early-education" className="py-2 text-sm text-foreground-700 cursor-pointer">宝宝早教</Link>
            <Link to="/category/mom-growth" className="py-2 text-sm text-foreground-700 cursor-pointer">妈妈成长</Link>
            <Link to="/about" className="py-2 text-sm text-foreground-700 cursor-pointer">关于我们</Link>
          </div>
        </div>
      )}
    </header>
  );
}